// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"65520357","286":"3cf5ab4c","435":"adb2b5f1","453":"d48df938","484":"e64f4430","574":"8b0f88d8","642":"e98a4b17","728":"ff5aaa71","872":"2039833b","994":"28a8e54e"}[chunkId] + ".chunk.js";
};